import React from "react";

import { Grid } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";
import { IoWarningOutline } from "react-icons/io5";

import ConfirmationModal from "../../../../../../../../components/Dialogs/ConfirmationModal";
import { Color } from "../../../../../../../../components/Form/Button";
import { ErrorLine, ErrorTitle } from "../UploadModal/styles";

type UploadErrorModalProps = {
  isOpen: boolean;
  uploadDataError?: string[];
  fileName?: string;
  onClose: () => void;
  onEditFile: () => void;
};

export const UploadErrorModal = ({
  isOpen,
  uploadDataError,
  fileName,
  onClose,
  onEditFile,
}: UploadErrorModalProps) => {
  const { t: translate } = useTranslation();

  return (
    <ConfirmationModal
      open={isOpen}
      type="alert"
      leftIconTitle={<IoWarningOutline color={colors.error500} />}
      closeModal={onClose}
      customColorCancel={Color.TEXT_INFO}
      submit={onEditFile}
      customColorSave={Color.ERROR}
      textSubmit={translate("tryAgain2")}
      title={translate("errorsFound")}
      width="35%"
    >
      <Grid container direction="row" spacing={4}>
        <Grid item xs={12} container direction="row">
          <ErrorTitle item xs={12}>
            <span>{`${translate("on")} ${fileName} ${translate("csv").toLowerCase()}, ${translate(
              "weHaveFoundSomeErros"
            )}.`}</span>
          </ErrorTitle>
          <ErrorTitle item xs={12}>
            <span>{translate("youShouldAdjustThoseLinesToproceed")}:</span>
          </ErrorTitle>
        </Grid>
        <Grid item xs={12} container direction="row">
          {uploadDataError?.map((error, index) => (
            <ErrorLine item xs={12} key={index}>
              {error}
            </ErrorLine>
          ))}
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};
